// extracted by mini-css-extract-plugin
export default {"FAQContainer":"MyFAQ_FAQContainer__lBRJf","FAQHeaderContainer":"MyFAQ_FAQHeaderContainer__pWppE","FAQContentContainer":"MyFAQ_FAQContentContainer__yGbGA"};